/* eslint-disable react/no-unescaped-entities */
import { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import GoogleMap from 'google-map-react'

import EllipsisText from 'react-ellipsis-text'
import Layout from '../components/Layout'
import SideWidget from '../components/SideWidget'
import { withTranslation, Link, i18n } from '../i18n'
import mapStyles from '../styles/mapStyles'
import getConfig from 'next/config'


import {
  Container,
  PerformanceEntry,
  MapSection,
  MapBackground,
  PlaceRegisterLink
} from '../styles/stageStyles'
import Footer from '../components/Footer'
import DescriptionSection from '../components/DescriptionSection'
import { fetchSinglePlace } from '../api/places'
import { Star } from '../public/static/svgs/Star'
import { favoriteRoute } from '../api/routes'
import { MapWidget } from '../components/MapWidget'
import { MapMiniWidget } from '../components/MapMiniWidget'

const { publicRuntimeConfig } = getConfig()

@inject('store')
@observer
class Place extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    store: PropTypes.instanceOf(Object).isRequired
  }

  state = {
    widgetClosed: false,
    windowWidth: 1440
  }

  static async getInitialProps({ req, query, mobxStore }) {
    const currentLanguage = req ? req.language : i18n.language
    const { token } = mobxStore.user
    const place = query.place || await fetchSinglePlace(query, currentLanguage, token)
    mobxStore.setPlace(place)
    return {
      namespacesRequired: ['common', 'about', 'contacts', 'artists', 'auth', 'reset-password']
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
    this.checkWindowWidth()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    this.checkWindowWidth()
    this.setState({ windowWidth: window.innerWidth })
  }

  checkWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth })
  }

  onStarPress = (id, token, favorited, updatePerformance, toggleLoginModal) => {
    if (!token) {
      toggleLoginModal(true, this.props.t('common:make_an_account'))
    } else {
      favoriteRoute(id, 'performances', undefined, token, favorited)
        .then(() => {
          updatePerformance(id)
        })
    }
  }

  onRegisterPress = () => {
    const {
      t,
      store: {
        toggleLoginModal,
        user: { token }
      }} = this.props
    if (!token) {
      toggleLoginModal(true, t('common:make_an_account'))
    }
  }

  render() {
    const {
      t,
      store: {
        updatePerformance,
        toggleLoginModal,
        place: {
          name, description, links, address, partner, kassyru_id, area_name, area_description,
          phone, header_image, photo, tags, experts, coordinates: [lat, lng], performances
        },
        user: {
          token
        }
      }
    } = this.props
    const width = this.state.windowWidth
    const registrationData = token? {
      'data-kassy-db': 'ekb',
      'data-kassy-agent_id': 'uralmusicnight.ru',
      'data-kassy-event_id': kassyru_id,
    } : {}

    return (
      <Layout meta={{ title: name, description, image: photo }} coverImageUrl={header_image || 'places-cover'}>
        <Container>
          <DescriptionSection
            header={name}
            subHeader={area_name}
            description={description}
            subDescription={area_description}
            links={links}
            tags={tags}
            width={width}
            experts={experts}
            partner={partner}
            className="descriptionSection"
          >
            {kassyru_id && <PlaceRegisterLink href="#" {...registrationData} onClick={this.onRegisterPress}>
              <img {...registrationData} src="/static/images/icon-registration.svg" alt="" />
                {t('place-register')}
              </PlaceRegisterLink>}
              <SideWidget header={t('artists:STAGE_PROGRAM')} className="widget" key="0">
                {performances.length > 0 ? (performances.map(({
                  id, favorited, time, name: pName, artist, start_datetime
                }) => {
                  const humanHref = `/artist/${artist.id}/${artist.slug}`
                  return (
                    <PerformanceEntry key={id}>
                      <span className="timeEntry">
                        <button onClick={() => {
                          this.onStarPress(id, token, favorited, updatePerformance, toggleLoginModal)
                        }}
                        >
                          <Star className="star" filled={favorited} />
                        </button>
                        <h3 className="timeHeader"><time dateTime={start_datetime}>{time}</time></h3>
                      </span>
                      <Link href={`/artist?id=${artist.id}`} as={humanHref}>
                        <a
                          className="placeLink"
                          href={humanHref}
                        >
                          <EllipsisText text={pName} length={66} />
                        </a>
                      </Link>
                    </PerformanceEntry>
                  )
                }))
                  : (
                    <div className="scheduleNotReady">
                      {t('schedule_is_not_ready')}
                    </div>
                  )}
              </SideWidget>

          </DescriptionSection>
          {width <= 768 &&
            <MapMiniWidget
              phone={phone}
              photo={photo}
              address={address}/>}
          <MapSection>
              {width > 768 &&
                <MapMiniWidget
                  phone={phone}
                  photo={photo}
                  address={address}/>}
              <MapBackground
                src="/static/images/map-white-background@3x.png"
                alt="map background"
                width={width}
              />
              <iframe
                frameBorder="0"
                src={`https://www.google.com/maps/embed/v1/place?key=${publicRuntimeConfig.googleApiKey}&q=${lat},${lng}`}>
              </iframe>
              {/* <GoogleMap
               bootstrapURLKeys={{ key: publicRuntimeConfig.googleApiKey }}
               defaultCenter={{
                 lat: lat - (width > 400 ? 0.007 : 0.004), lng
               }}
               defaultZoom={14}
               options={{
                 styles: mapStyles,
                 gestureHandling: 'cooperative'
               }}
              >
               <MapWidget
                 phone={phone}
                 photo={photo}
                 address={address}
                 lat={lat}
                 lng={lng}
                 closed={this.state.widgetClosed}
                 onPress={() => {
                   this.setState(prevState => ({ widgetClosed: !prevState.widgetClosed }))
                 }}
               />
              </GoogleMap> */}
            </MapSection>
          <Footer />
        </Container>
      </Layout>
    )
  }
}

export default withTranslation(['common', 'artists'])(Place)
